import type { FC } from "react";
import { useState } from "react";
import { canCreateSneak, setKeyParam } from "app/pages/sneakpeek/utilities";
import ResultsMain from "app/pages/sneakpeek/components/ResultsMain";

import DurationService from "app/services/DurationService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const SneakpeekResultsPage: FC<any> = (props) => {
    const [isNavError, setIsNavError] = useState<boolean>(false);
    const { queryId, duration, ...restOfParams } = proNavigator.getParams();
    const { from, to } = DurationService.getDurationData(duration).forAPI;
    const params = {
        queryId,
        duration,
        from,
        to,
        ...restOfParams,
    };

    if (!canCreateSneak() && !queryId) {
        setIsNavError(true);
        setTimeout(() => {
            proNavigator.go("digitalsuite-home");
        }, 3000);
    }
    if (isNavError) {
        return (
            <div className="alert alert-danger">
                <strong>Oops! Can&apos;t create a sneak! redirecting...</strong>
            </div>
        );
    }
    return (
        <ResultsMain
            selectedQueries={queryId}
            params={setKeyParam(params)}
            navigator={proNavigator}
        />
    );
};

